import _ from 'lodash';
import store from 'services/redux/store'
import { managementConstants } from 'services/redux/management/constants'
import { setManagement } from 'services/redux/management/actions'
import ObjectTimeslot from 'utils/objects/timeslot'
import HelperString from 'utils/helper-string'
import HelperValidate from 'utils/helper-validate'
import { FormFieldsConstants } from 'utils/constants/form-constants'
import HelperDate, { dateFormat } from 'utils/helper-date'

export default class ObjectTimeslotForm {
	
	static createFormKey = ( key ) => {
		if( !_.startsWith( key, 'timeslot|' ) ) {
			key = `timeslot|${key}`;
		}
		
		return key;
	}
	
	static createFormField = ( key, { exists = false, disableKindBooking = false, itemKind, itemMode } = {} ) => {
		key = this.createFormKey( key )
		
		return {
			name: key,
			required: false,
			hide_label: true,
			type: FormFieldsConstants.TIMESLOT,
			props: {
				exists,
				disableKindBooking,
				itemKind,
				itemMode,
				onRemove: ObjectTimeslotForm.removeFromFormFields.bind( this, key )
			}
		}
	}
	
	static setFormFields = ( timeslots, { disableKindBooking = false, itemKind, itemMode } = {} ) => {
		const formFields = [];
		
		// Order the timeslots by start time
		const formValues = ObjectTimeslot.groupTimeSlots( timeslots, { disableKindBooking: disableKindBooking } );
		
		const formFieldProps = {
			exists: true,
			disableKindBooking,
			itemKind,
			itemMode,
		}

		_.forEach( formValues, ( value, key ) => {
			formFields.push( ObjectTimeslotForm.createFormField( key, formFieldProps ) );
		});
		
		ObjectTimeslotForm.storeInStore({
			formFields,
			formValues
		})
	}
	
	static addFormField = ( props ) => {
		const objects = store.getState().management[ managementConstants.SELECTED_TIMESLOTS ]
		
		const key = this.createFormKey( HelperString.random() )
		
		const fields = [ ...objects.formFields ]
		fields.push( ObjectTimeslotForm.createFormField( key, { ...props } ) )
		
		const values = { ...objects.formValues }
		
		// Get the last set value and use that to create a new field
		const lastValue = _.last( Object.values( values ) )
		if( HelperValidate.isValid( lastValue ) ) {
			const dateStart = HelperDate.date( lastValue.timeslot_start, dateFormat.FULL_TIME )
			const dateEnd = HelperDate.date( lastValue.timeslot_end, dateFormat.FULL_TIME )
			const difference = dateEnd.diff( dateStart, 'minutes' )
			
			values[ key ] = {
				...lastValue,
				timeslot_start: dateEnd.format( dateFormat.FULL_TIME ),
				timeslot_end: HelperValidate.isValid( difference ) ? dateEnd.add( difference, 'minutes' ).format( dateFormat.FULL_TIME ) : null,
				translations: [],
				timeslots: _.map( lastValue.timeslots, o => {
					return (
						{
							timeslot_day: o.timeslot_day,
							kind: o?.kind,
							sub_kind: o?.sub_kind
						}
					);
				}),
			}
		}
		
		ObjectTimeslotForm.storeInStore({
			...objects,
			formFields: fields,
			formValues: values
		})
	}
	
	static removeFromFormFields = ( key ) => {
		const objects = store.getState().management[ managementConstants.SELECTED_TIMESLOTS ]
		
		const fields = [];
		_.forEach( objects.formFields, (o) => {
			if( o.name !== key ) {
				fields.push( o );
			}
		})
		
		const values = {};
		_.forEach( objects.formValues, (o, k) => {
			if( k !== key ) {
				values[ k ] = o;
			}
		})
		
		ObjectTimeslotForm.storeInStore({
			formFields: fields,
			formValues: values
		})
	}
	
	static storeInStore = ( payload ) => {
		store.dispatch( setManagement( managementConstants.SELECTED_TIMESLOTS, payload ) )
	}
}
